import apiCall from "./apiCall";

const ajaxVoucher = {
  
   async fetchStats() {
    return await apiCall('platform/webclient/voucher_stats', []);
  },
  async fetchTransactions(filters) {
    return await apiCall('platform/webclient/list_vouchers', filters);
  },
  async createVoucher(data) {
    return await apiCall('platform/webclient/new_manual_voucher', data);
  },

  async fetchRevenueTrends() {
    return await apiCall('platform/webclient/revenue_trends', []);
  },

  async fetchRevenueCharts() {
    return await apiCall('platform/webclient/revenue_charts', []);
  },

  async fetchPopularPlansChart() {
    return await apiCall('platform/webclient/popular_plans_chart', []);
  },

  async fetchUserMetrics() {
    return await apiCall('platform/webclient/user_metrics', []);
  },

  async fetchCustomers(data) {
    return await apiCall('platform/webclient/customer_list', data);
  },
  async fetchCustomerKPIs(data) {
    return await apiCall('platform/webclient/customer_kpis', data);
  },
  async fetchRecentDeviceActivity(data) {
    return await apiCall('platform/webclient/recent_device_activity', data);
  },
  async fetchRevocationQueue() {
    return await apiCall('platform/webclient/revocation_queue', []);
  },
  async revokeVoucher(data) {
    return await apiCall('platform/webclient/revoke_voucher', data);
  },

  async fetchTrafficUsage(data) {
    return await apiCall('platform/webclient/traffic_usage', data);
  },
  async fetchSalesSummary(data) {
    return await apiCall('platform/webclient/sales_summary', data);
  },
  async fetchSalesBreakdown(data) {
    return await apiCall('platform/webclient/sales_breakdown', data);
  },
  async fetchMyRecentVouchers() {
    return await apiCall('platform/webclient/my_recent_vouchers', []);
  },
  async fetchMyVouchers(data) {
    return await apiCall('platform/webclient/my_vouchers', data);
  },
  async sellVoucher(data) {
    return await apiCall('platform/webclient/sell_voucher', data);
  },
  async fetchVendorStats() {
    return await apiCall('platform/webclient/vendor_stats', []);
  },
  async fetchVendors(data){
    return await apiCall('platform/webclient/list_vendors', data);
  },
  async depositFloat(data){
    return await apiCall('platform/webclient/deposit_float', data);
  },
  async withdrawFloat(data){
    return await apiCall('platform/webclient/withdraw_float', data);
  },
};

export default ajaxVoucher;